var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFilter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 511 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M492.477 0H20.5C9.453 0 .5 8.953.5 20c0 55.695 23.875 108.867 65.504 145.871l87.59 77.852c15.187 13.5 23.898 32.898 23.898 53.222v195.032c0 15.937 17.813 25.492 31.09 16.636l117.996-78.66c5.563-3.71 8.906-9.953 8.906-16.64V296.945c0-20.324 8.711-39.722 23.899-53.222l87.586-77.852C488.598 128.867 512.473 75.695 512.473 20c0-11.047-8.953-20-19.996-20zm-72.082 135.973l-87.586 77.855c-23.72 21.086-37.325 51.379-37.325 83.113V402.61l-77.996 51.996v-157.66c0-31.738-13.605-62.03-37.324-83.117l-87.586-77.851c-28.07-24.957-45.988-59.153-50.785-95.98H471.18c-4.797 36.827-22.711 71.023-50.785 95.976zm0 0"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter.300dae0a.svg";
export { ForwardRef as ReactComponent };